import React from 'react';

import { EmployerWidgetActions } from '../components/EmployerWidgetActions';
import { PersonBreastfeeding } from 'assets/icons/Icons';
import { Heading } from 'components/v2/Typography/Heading';
import { Text } from 'components/v2/Typography/Text';
import { Patient } from 'kb-shared';
import { DashboardWidgetList } from 'screens/Dashboard/DashboardSettings/DashboardSettings.types';
import { isHiddenWidget } from 'screens/Dashboard/DashboardSettings/DashboardSettings.utils';
import {
  IconContainer,
  IllustratedBackgroundWidget,
  TextRow,
  WidgetTitleContainer
} from 'screens/Dashboard/Widgets/Widgets.styled';
import { showSaicWidget } from 'screens/Dashboard/Widgets/Widgets.utils';

import { widgetActions } from './SaicWidget.utils';

interface Props {
  patient: Patient;
  hiddenWidgets?: DashboardWidgetList;
}

export const SaicWidget = ({ patient, hiddenWidgets }: Props) => {
  if (!showSaicWidget(patient) || isHiddenWidget(hiddenWidgets, 'saic')) return null;

  return (
    <IllustratedBackgroundWidget variant={8}>
      <IconContainer $iconWidth={42} $iconHeight={48}>
        <PersonBreastfeeding type="solid" />
      </IconContainer>
      <WidgetTitleContainer>
        <Heading tag="div" styledAs="h2">
          SAIC Baby Prep Program
        </Heading>
      </WidgetTitleContainer>
      <TextRow>
        <Text fontStyle="semibold">
          The Baby Prep Program is provided by Kindbody and connects parents to be with educational
          resources and trimester-specific support.
        </Text>
      </TextRow>
      <TextRow>
        <Text>
          Pregnancy is a time of excitement and anxiety and your Kindbody team is so excited to be a
          part of this journey with you!
          <br />
          Our goal is to provide you information that is evidence-based and supported by the
          American College of Obstetrics and Gynecology.
          <br />
          Click on the links below to get started!
        </Text>
      </TextRow>
      <EmployerWidgetActions actions={widgetActions} />
    </IllustratedBackgroundWidget>
  );
};
